module.exports = __webpack_public_path__ + "images/category_lp/common/reason1-man-30_5b4ffa8df9ce09764c5987aa36fb1c79.jpg";